import localforage from 'localforage'

const localstorageCartKey = 'v1_shop_cart'
var isInternalUpdate = false

const updateStoreFromStrorage = async function (store) {
  let storeCartState = await localforage.getItem(localstorageCartKey)

  store.commit('cart/initialize')

  if (!storeCartState || storeCartState.expires < new Date()) {
    // if there is no cart saved in storage, or the saved state is expired,
    // clear the cart
    store.commit('cart/clear')
    return
  }

  isInternalUpdate = true
  await store.dispatch('cart/initialize', storeCartState.value)
  isInternalUpdate = false
}

export default function cartStorage () {
  return async (store) => {
    // subscribe for changes in the store
    store.subscribe(async (mutation, state) => {
      if (isInternalUpdate) return
      if (!mutation.type.includes('cart') || mutation.type === 'cart/initialize') return

      const storeCartState = JSON.parse(JSON.stringify(state.cart))

      // Storage expires in 5 days
      let storeExipresAt = new Date()
      storeExipresAt.setDate(storeExipresAt.getDate() + 5)

      await localforage.setItem(localstorageCartKey,
        {
          value: storeCartState,
          expires: storeExipresAt
        }
      )
    })
  }
}

// initialize the store with the state from the storage
export const initializeCart = async (store) => updateStoreFromStrorage(store)



// WEBPACK FOOTER //
// ./client/store/plugins/cartStorage.js